import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import DocAccordion from './components/DocAccordion';
import { patriotDocumentsData } from '@/mocks/documents';
import { Link } from 'react-router-dom';

export default function PatriotDocumentsPage() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language || 'kk';

  const isEn = lang.startsWith('en');
  const isRu = lang.startsWith('ru');

  return (
    <div className="min-h-screen bg-background-950">
      <Navbar />

      {/* Hero Banner */}
      <div className="relative h-56 md:h-72 flex items-end overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Kazakhstan%20military%20youth%20patriotic%20training%20soldiers%20outdoor%20exercises%20Kazakh%20athletes%20strong%20discipline%20dramatic%20dark%20cinematic%20lighting%20no%20text%20no%20flags&width=1600&height=500&seq=patriot-banner-01&orientation=landscape"
            alt="Patriot Documents"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/70 to-background-950/30" />
        </div>
        <div className="relative w-full px-4 md:px-12 pb-10">
          <div className="flex items-center gap-2 text-xs text-foreground-600 mb-3 font-label tracking-widest uppercase">
            <Link to="/" className="hover:text-accent-500 transition-colors">
              {t('nav.home', isEn ? 'Home' : isRu ? 'Главная' : 'Басты бет')}
            </Link>
            <i className="ri-arrow-right-s-line" />
            <Link to="/documents" className="hover:text-accent-500 transition-colors">
              {t('nav.documents', isEn ? 'Documentation' : isRu ? 'Документация' : 'Құжаттама')}
            </Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-foreground-400">Patriot</span>
          </div>
          <h1 className="font-heading text-3xl md:text-5xl text-foreground-50 uppercase tracking-widest">
            {isEn ? '«Patriot» ' : isRu ? 'Документация ' : '«Patriot» '}
            <span className="text-accent-500">{isEn ? 'Documentation' : isRu ? '«Patriot»' : 'құжаттамасы'}</span>
          </h1>
        </div>
      </div>

      {/* Content */}
      <main className="w-full max-w-5xl mx-auto px-4 md:px-8 py-12">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-8 h-px bg-accent-500" />
          <p className="text-xs font-label tracking-widest uppercase text-accent-500">
            {isEn ? '«Patriot» Military-Patriotic Club' : isRu ? 'Военно-патриотический клуб «Патриот»' : '«Патриот» әскери-патриоттық клубы'}
          </p>
        </div>

        <DocAccordion items={patriotDocumentsData} />
      </main>

      <Footer />
    </div>
  );
}